import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["edit", "show", "form", "requiredField"];
  connect() {
    // A morph re-renders validation errors without re-firing connect, so the
    // auto-open check must also run after every morph.
    this.morphReopen = this.morphReopen || (() => this.openIfError());
    document.addEventListener("turbo:morph", this.morphReopen);
    this.openIfError();
  }

  disconnect() {
    document.removeEventListener("turbo:morph", this.morphReopen);
  }

  openIfError() {
    // Scoped to the form, not the element: a section whose trigger sits outside the form
    // wraps other records too, and their errors are not this form's business.
    const errorField = this.hasFormTarget && this.formTarget.querySelector(".has-error");
    if (
      (errorField || this.hasEmptyRequiredField) &&
      this.formTarget.classList.contains("no-show")
    ) {
      this.toggleForm();
    }
  }

  closeForm() {
    if (this.isOpen && !this.hasEmptyRequiredField) {
      this._closeForm();
    }
  }

  toggleForm(event) {
    if (event) {
      event.preventDefault();
    }
    if (this.isMobileAdminOpen) {
      return;
    }
    this.showElement.classList.toggle("no-show");
    if (this.hasEditTarget) {
      this.editTarget.classList.toggle("no-show");
    }
    this.formTarget.classList.toggle("no-show");
    this.element.dispatchEvent(
      new CustomEvent("section-toggled", { bubbles: true, cancelable: true })
    );
  }

  _closeForm() {
    this.showElement.classList.remove("no-show");
    if (this.hasEditTarget) {
      this.editTarget.classList.remove("no-show");
    }
    this.formTarget.classList.add("no-show");
  }

  // Read off the form rather than the show block, which a section with a persistent
  // trigger does not have.
  get isOpen() {
    return this.hasFormTarget && !this.formTarget.classList.contains("no-show");
  }

  get hasEmptyRequiredField() {
    return this.requiredFieldTargets.filter((f) => f.value === "" || f.value === "[]").length > 0;
  }

  get isMobileAdminOpen() {
    return this.application.getControllerForElementAndIdentifier(
      document.querySelector("section.admin"),
      "effects"
    ).isAdminOpen;
  }

  get showElement() {
    if (!this.hasShowTarget) {
      return document.createElement("div");
    }

    return this.showTarget;
  }
}
